import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AnalyticsService } from '../../services/analytics.service';
import {
  AuthenticationService,
  ConfigService
} from '@core-argos-angular-artifact/core';

@Component({
  selector: 'my-account-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Output() logout: EventEmitter<void> = new EventEmitter();

  userLogged = false;

  redirectLink: string;

  constructor(
    private readonly authService: AuthenticationService,
    private readonly analyticsService: AnalyticsService,
    private readonly configService: ConfigService
  ) {
    this.redirectLink = this.configService.getConfig()?.productUrl;
  }

  ngOnInit(): void {
    this.userLogged = this.authService.isAuthenticated();
    if (this.userLogged) {
      this.analyticsService.sendLogin();
    }
  }

  doLogout(): void {
    this.logout.emit();
  }
}
